import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider, useAuth } from './AuthContext';
import LoginPage      from './pages/LoginPage';
import QueuePage      from './pages/QueuePage';
import KYCPage        from './pages/KYCPage';
import AssessmentPage from './pages/AssessmentPage';
import CASPage        from './pages/CASPage';
import CASDashboard   from './pages/CASDashboard';
import ARPortfolio    from './pages/ARPortfolio';
import ARDashboard    from './pages/ARDashboard';
import MonthlyReview  from './pages/MonthlyReview';
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
function PrivateRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Loading...</div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return (
    <div style={{ padding: 40, textAlign: 'center', color: '#c5221f' }}>
      Access denied.
    </div>
  );
  return children;
}
function AppRoutes() {
  const { user } = useAuth();
  const location = useLocation();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={
        <PrivateRoute>
          {user?.role === 'sales'
            ? <Navigate to="/cas/ar" replace />
            : <QueuePage />
          }
        </PrivateRoute>
      } />
      <Route path="/ar" element={
        <PrivateRoute allowedRoles={['approver']}>
          <ARDashboard />
        </PrivateRoute>
      } />
      <Route path="/kyc/:mcRow" element={
        <PrivateRoute allowedRoles={['kyc', 'approver']}>
          <KYCPage />
        </PrivateRoute>
      } />
      <Route path="/assessment/:mcRow" element={
        <PrivateRoute allowedRoles={['approver']}>
          <AssessmentPage key={location.pathname} />
        </PrivateRoute>
      } />
      <Route path="/cas/ar" element={
        <PrivateRoute allowedRoles={['sales']}>
          <ARPortfolio />
        </PrivateRoute>
      } />
      <Route path="/cas/dashboard" element={
        <PrivateRoute allowedRoles={['sales']}>
          <CASDashboard />
        </PrivateRoute>
      } />
      <Route path="/cas/monthly-review" element={
        <PrivateRoute allowedRoles={['sales']}>
          <MonthlyReview />
        </PrivateRoute>
      } />
      <Route path="/cas" element={
        <PrivateRoute allowedRoles={['sales', 'kyc']}>
          <CASPage />
        </PrivateRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
export default function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}